import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import EmailVerifyModal from './EmailVerifyModal';
import { getApiBaseUrl } from '../apiBase';

const DISMISSED_KEY = 'emailVerifyDismissedThisSession';
// На этих страницах не нагоняем — либо ещё не залогинены, либо это отдельный
// сценарий (киоск СКУД — синтетическая учётка устройства, ей email не нужен).
const EXCLUDED_PREFIXES = ['/login', '/register', '/select-profile', '/skud/kiosk', '/demo-login', '/activate', '/invite'];

export default function EmailVerifyGate({ children }) {
    const location = useLocation();
    const [show, setShow] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const emailVerified = localStorage.getItem('emailVerified') === 'true';
        const dismissed = sessionStorage.getItem(DISMISSED_KEY) === 'true';
        const excluded = EXCLUDED_PREFIXES.some(p => location.pathname.startsWith(p));
        const role = localStorage.getItem('role');

        const candidate = !!token && !emailVerified && !dismissed && !excluded && role !== 'ScannerKiosk';
        if (!candidate) {
            setShow(false);
            return undefined;
        }

        // Сохранённый флаг мог устареть (старая сессия, обновление токена): спрашиваем сервер, нужно ли окно на самом деле.
        // Если у человека уже есть email — окно не показываем и запоминаем это.
        let cancelled = false;
        axios.get(`${getApiBaseUrl()}/auth/email/status`, { headers: { Authorization: `Bearer ${token}` } })
            .then(({ data }) => {
                if (cancelled) return;
                if (data?.needsPrompt === false) {
                    localStorage.setItem('emailVerified', 'true');
                    if (data.email) localStorage.setItem('userEmail', data.email);
                    setShow(false);
                } else {
                    setShow(true);
                }
            })
            .catch(() => { if (!cancelled) setShow(false); });
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    function handleDismiss() {
        sessionStorage.setItem(DISMISSED_KEY, 'true');
        setShow(false);
    }

    function handleVerified() {
        setShow(false);
    }

    return (
        <>
            {children}
            {show && (
                <EmailVerifyModal
                    initialEmail={localStorage.getItem('userEmail') || ''}
                    onVerified={handleVerified}
                    onDismiss={handleDismiss}
                />
            )}
        </>
    );
}
